
import { MapLocation } from '@/types/location';

export const digitalBridgeScreens: MapLocation[] = [
  {
    id: 10003,
    name: "Digital Bridge Screen – Al Kharj",
    type: "Digital Bridge Screen",
    devices: 2,
    coordinates: [24.15496013596722, 47.300354932863065],
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital bridge screen with 2 faces\nPrice: 2,715 SAR per face per day",
      screenDimensions: "Bridge Screen"
    }
  },
  {
    id: 10004,
    name: "Digital Bridge Screen – Dawadmi",
    type: "Digital Bridge Screen",
    devices: 2,
    coordinates: [24.50688969064852, 44.39433381921343],
    region: "Dawadmi",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital bridge screen with 2 faces\nPrice: 2,715 SAR per face per day",
      screenDimensions: "Bridge Screen",
      referenceImage: "/images/7f6219aa-76d3-44bf-84c0-114798095017.png"
    }
  },
  {
    id: 10005,
    name: "Digital Bridge Screen – Tabuk",
    type: "Digital Bridge Screen",
    devices: 2,
    coordinates: [28.432973633491343, 36.57056688113401],
    region: "Tabuk",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital bridge screen with 2 faces\nPrice: 2,715 SAR per face per day",
      screenDimensions: "Bridge Screen"
    }
  },
  {
    id: 10006,
    name: "Digital Bridge Screen – Tabuk 2",
    type: "Digital Bridge Screen",
    devices: 2,
    coordinates: [28.423689373264573, 36.57188247209882],
    region: "Tabuk",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital bridge screen with 2 faces\nPrice: 2,715 SAR per face per day",
      screenDimensions: "Bridge Screen"
    }
  },
  {
    id: 10007,
    name: "Digital Bridge Screen – Tabuk 3",
    type: "Digital Bridge Screen",
    devices: 2,
    coordinates: [28.411616384180387, 36.55657773984494],
    region: "Tabuk",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital bridge screen with 2 faces\nPrice: 2,715 SAR per face per day",
      screenDimensions: "Bridge Screen"
    }
  },
  {
    id: 10008,
    name: "Digital Bridge Screen – Tabuk 4",
    type: "Digital Bridge Screen",
    devices: 2,
    coordinates: [28.39348857961158, 36.54911353490746],
    region: "Tabuk",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital bridge screen with 2 faces\nPrice: 2,715 SAR per face per day",
      screenDimensions: "Bridge Screen"
    }
  },
  {
    id: 10009,
    name: "Digital Bridge Screen – Hail",
    type: "Digital Bridge Screen",
    devices: 2,
    coordinates: [27.555102635183573, 41.674721115995],
    region: "Hail",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital bridge screen with 2 faces\nPrice: 2,715 SAR per face per day",
      screenDimensions: "15m x 2m",
      referenceImage: "/images/39ae0f84-1023-43fd-be66-8f4e3c3a233a.png"
    }
  },
  {
    id: 10010,
    name: "Digital Bridge Screen – Hail 2",
    type: "Digital Bridge Screen",
    devices: 2,
    coordinates: [27.46903346741311, 41.70123590771913],
    region: "Hail",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital bridge screen with 2 faces\nPrice: 2,715 SAR per face per day",
      screenDimensions: "20m x 3m",
      referenceImage: "/images/f955854c-b363-421a-9942-4f6b62293c4b.png"
    }
  },
  {
    id: 10011,
    name: "Digital Bridge Screen – Hafar Al Batin",
    type: "Digital Bridge Screen",
    devices: 2,
    coordinates: [28.365876641263966, 45.99211403752344],
    region: "Hafar Al Batin",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital bridge screen with 2 faces\nPrice: 2,715 SAR per face per day",
      screenDimensions: "18m x 3m",
      referenceImage: "/images/29246d97-b7e1-4daa-b084-8ac6fd50251d.png"
    }
  },
  {
    id: 10012,
    name: "Digital Bridge Screen – Hafar Al Batin 2",
    type: "Digital Bridge Screen",
    devices: 2,
    coordinates: [28.365769708065088, 45.96235238076371],
    region: "Hafar Al Batin",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital bridge screen with 2 faces\nPrice: 2,715 SAR per face per day",
      screenDimensions: "15m x 3m",
      referenceImage: "/images/7aa5fa61-1b84-4a70-9822-c43cbda443fc.png"
    }
  }
];
